<main class="dialog-body">
  <div class="dialog-header">
    <div class="dialog-header-text">
      {{
        isEditMode
          ? eventCategoryMode ? "Edit Work experience type" :"Edit FAQ category"
          : eventCategoryMode
            ? "Work experience type"
            : "FAQ category"
      }}
    </div>
    <div class="cros-icon" (click)="onCancel()" [class.disabled]="isProcessing">
      <img src="assets/images/cross-icon.svg" class="cross-icon" />
    </div>
  </div>

  <mat-dialog-content *ngIf="eventCategoryMode">
    <div class="dialog-content">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="Type name"
            [required]="true"
            placeholder="Enter work experience type name"
            type="text"
            formControlName="typeName"
            [control]="form.get('typeName')"
            [customErrorMessages]="customErrorMessages.typeName"
          >
          </app-input>
        </div>

        <div class="form-group mt-3" *ngIf="eventCategoryMode">
          <app-input
            context="Normal"
            class="form-item"
            label="Description"
            [required]="true"
            placeholder="Enter description"
            type="textarea"
            formControlName="description"
            [control]="form.get('description')"
            [customErrorMessages]="customErrorMessages.description"
          >
          </app-input>
        </div>
      </form>
    </div>

  </mat-dialog-content>

  <mat-dialog-content *ngIf="!eventCategoryMode">
    <div class="dialog-content">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <app-input
            context="Normal"
            class="form-item"
            label="Category Name"
            [required]="true"
            placeholder="Enter your category name"
            type="text"
            formControlName="name"
            [control]="form.get('name')"
            [customErrorMessages]="customErrorMessages.name"
          >
          </app-input>
        </div>       
      </form>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="action-buttons">
    <button
      class="cancel-button"
      (click)="onCancel()"
      [disabled]="isProcessing"
    >
      Cancel
    </button>
    <button
      class="update-button"
      (click)="onSubmit()"
      [disabled]="isProcessing"
    >
      <span *ngIf="!isProcessing">{{ isEditMode ? "Update" : "Submit" }}</span>
      <span *ngIf="isProcessing" class="submit-loading">
        <span class="spinner"></span>
        Submiting...
      </span>
    </button>
  </mat-dialog-actions>
</main>
